import React from 'react';
import Head from 'next/head';
import BaseLayout from 'layouts/BaseLayout';
import Header from 'components/CreateGraphicalAbstract/Header';
import MainContent from 'components/CreateGraphicalAbstract/MainContent';

const schemeData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Can I publish infographics I create with Mind the Graph? How do I cite them?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'All content stored in and created with mindthegraph.com is available under a free culture Creative Commons license. Free users can publicly present infographics created with the Mind the Graph platform and use the illustrations available on the website. However, Mind The Graph must be cited, and the use of the watermark is mandatory. Paid subscribers are recognized as authors and are entitled to full rights to their creations, with the rights and ability to transfer authorial rights to third-party publishers without previous consulting Mind The Graph. So, if youre a paid user, you dont need to attribute credit to Mind the Graph (but well be happy if you do!).',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I use Mind the Graph for free?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Mind the Graph is based on a freemium model and you can use it for free for as long as you wish. We dont request any credit card information upon registration. However, keep in mind that the Free plan is for you to get to know the platform and informal communication with your peers or educational environments. As a free user, you must retain Mind the Graphs watermark in all cases and cite the platform in formal communication, publications, lectures, and presentations. If you ever want to upgrade, all paid plans provide access to more figures, watermark-free images, and Creative Commons licenses for your creations.',
      },
    },
    {
      '@type': 'Question',
      name: 'Do I need to pay to request an illustration?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mind the Graph is the worlds largest scientifically accurate illustrations gallery. There are chances that we have the illustration you are looking for. However, if we still dont have an illustration that meets your needs, you can subscribe and request it for free. Check our tutorial for help.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the benefits of a paid plan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'A Paid plan at Mind the Graph gets you extra features and resources! All paid plans offer a wider range of illustrations, watermark-free use of images, and Creative Commons licenses for your creations. Also, youll have access to premium customer support, free personalized illustrations, numerous templates, and higher limits on the use of scientific illustrations. Dont forget to compare plans here.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Scientific figures are a creative way to communicate the results of scientific research through a visual resource. Its a manner to present science in an accessible, useful, easy-to-understand style to allow more people to connect with science.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do you make good scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'To make good scientific figures youll need to define your goals and audience, set a strong brief, and know what is the main data and what is the most important information that your readers need to understand to create self-explanatory science figures, understandable only by reading, without an extra explanation or content.',
      },
    },
    {
      '@type': 'Question',
      name: 'What should a good scientific figure include?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Good scientific figures include a combination of text, visuals, and design, complementing each other, to improve reading comprehension. Good scientific figures show all relevant information about the research in a clear and visually pleasing way so that the reader can understand it for himself.',
      },
    },
    {
      '@type': 'Question',
      name: 'Where can I make scientific figures?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mind The Graph is the best free platform for making scientific figures. This way, you ensure that your scientific figures have images with a consistent art style, scientifically accurate illustrations, templates with an intuitive reading flow, graphics, symbols, icons, and appropriate font styles. You can also publish your scientific figures designed with Mind The Graph in journals, magazines, blogs, social media, books, and more!',
      },
    },
    {
      '@type': 'Question',
      name: 'What is meant by graphical abstract?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ANSWER_9',
      },
    },
    {
      '@type': 'Question',
      name: 'How do you write a graphical abstract?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ANSWER_10',
      },
    },
    {
      '@type': 'Question',
      name: 'Is a graphical abstract required?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ANSWER_11',
      },
    },
    {
      '@type': 'Question',
      name: 'What is graphical abstract in IEEE?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ANSWER_12',
      },
    },
  ],
};

export default function CreateGraphicalAbstract() {
  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>Graphical Abstract Maker: Create Custom Templates | Mind the Graph</title>

        <meta
          key="description"
          name="description"
          content="Create powerful graphical abstracts for every journal in minutes with our graphical abstract maker. Access graphical abstract templates from 80+ scientific fields. Sign up to Mind the Graph for free"
        />
        <meta name="keywords" content="graphical abstract maker, graphical abstracts" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemeData) }}
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
